const ErrorMessage = ({ msg }) => {
  return (
    <div className="error_msg">
      <span className="msg">{msg}</span>
    </div>
  )
}

export default ErrorMessage
